import { 
    DateInput, 
    Edit, 
    SimpleForm, 
    TextInput, 
    required 
  } from 'react-admin';
  import { MyRichTextInput } from './utils';
  import { FileInput } from '../fileinputs/eventFileUpload';
  
  export function AchievementEdit(props) {
      return (
          <Edit {...props}>
              <SimpleForm>
                  <TextInput source="name" validate={required()} />
                  <MyRichTextInput source="description" />
                  <DateInput source="createdDate" />
                  <DateInput source="updatedDate" />
                  <FileInput source="images" edit add />
              </SimpleForm>
          </Edit>
      )
  }